import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import './styles.less';

function mapStateToProps(state) {
    return {
        dynamicQuestions: state.destination.dynamicQuestions
    };
}

export class DynamicQuestionsComponent extends PureComponent {
    render() {
        const {
            dynamicQuestions
        } = this.props;

        const questions = dynamicQuestions
            .filter(({heading, intro}) => heading && intro)
            .map(({heading, intro, answer, outro}, i) => {
                return (
                    <div className="col-md-12" key={`q${i}`}>
                        <h3>{heading}</h3>
                        <p>{intro}</p>
                        {answer ?
                            <ul className="dynamic-answers">
                                {answer.map((item, j) => (
                                    <li key={`q${i}a${j}`}> {item} </li>)
                                )}
                            </ul> : null
                        }
                        {outro ? <p>{outro}</p> : null}
                    </div>
                );
            });

        return (
            <div >
                {questions}
            </div>
        );
    }
}


export const DynamicQuestions = injectIntl(
    connect(mapStateToProps)(DynamicQuestionsComponent)
);
